import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../assets/img/banner.png'
import _imports_1 from '../assets/img/student_end_btn.png'
import _imports_2 from '../assets/img/student_btn.png'
import _imports_3 from '../assets/img/gr_end_btn.png'
import _imports_4 from '../assets/img/gr_btn.png'
import _imports_5 from '../assets/img/team_end_btn.png'
import _imports_6 from '../assets/img/team_btn.png'
import _imports_7 from '../assets/img/team_before_btn.png'
import _imports_8 from '../assets/img/rank_btn.png'
import _imports_9 from '../assets/img/prize_btn.png'
import _imports_10 from '../assets/img/rule_btn.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = { class: "links" }
const _hoisted_3 = { class: "student link" }
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = { class: "personal link" }
const _hoisted_6 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_7 = { class: "team link" }
const _hoisted_8 = {
  key: 0,
  src: _imports_5,
  alt: ""
}
const _hoisted_9 = {
  key: 2,
  src: _imports_7,
  alt: ""
}
const _hoisted_10 = { class: "btns" }
const _hoisted_11 = { class: "rank-btn btn" }
const _hoisted_12 = { class: "prize-btn btn" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "page-home",
    style: _normalizeStyle({'background-image': _ctx.activityData.templateConfig.homeBg ? 'url('+ _ctx.activityData.templateConfig.homeBg +')' : ''})
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isStudentEnd)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_2,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goPage('student'))),
              alt: ""
            }))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isPersonalEnd)
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_4,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goPage(''))),
              alt: ""
            }))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isTeamEnd)
          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
          : (_ctx.isTeamStart)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_6,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goPage('team'))),
                alt: ""
              }))
            : (_openBlock(), _createElementBlock("img", _hoisted_9))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          src: _imports_8,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goRank && _ctx.goRank(...args))),
          alt: ""
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("img", {
          src: _imports_9,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goPage('prize'))),
          alt: ""
        })
      ])
    ]),
    _createElementVNode("div", {
      class: "rule-btn",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goRule && _ctx.goRule(...args)))
    }, _hoisted_14)
  ], 4))
}